const norm = (value = '') => value.trim().toLocaleLowerCase('es').replace(/\s+/g, ' ');
const hasClassPrefix = (el, prefix) =>
  el instanceof Element && [...el.classList].some((className) => className.startsWith(prefix));

function directChildByPrefix(parent, tagName, prefix) {
  return [...parent.children].find(
    (child) => child.tagName.toLowerCase() === tagName && hasClassPrefix(child, prefix)
  );
}

function directAnchor(item) {
  return [...item.children].find((child) => child.tagName === 'A') || item.querySelector(':scope > a');
}

function buildNestedGroup(item) {
  const wrapper = [...item.children].find((child) => hasClassPrefix(child, 'header-menu-link-wrapper-'));
  const submenu = [...item.children].find((child) => hasClassPrefix(child, 'header-mobile-submenu-'));

  if (wrapper && submenu) {
    const sourceAnchor = wrapper.querySelector('a');
    if (!sourceAnchor) return null;

    const details = document.createElement('details');
    details.className = 'district-mobile-nav__subgroup';

    const summary = document.createElement('summary');
    summary.className = 'district-mobile-nav__subsummary';
    summary.textContent = sourceAnchor.textContent.trim();
    details.append(summary);

    const panel = document.createElement('div');
    panel.className = 'district-mobile-nav__subpanel';

    const href = sourceAnchor.getAttribute('href');
    if (href && href !== '#') {
      const all = document.createElement('a');
      all.className = 'district-mobile-nav__sublink district-mobile-nav__view-all';
      all.href = href;
      all.textContent = `Ver todo ${sourceAnchor.textContent.trim()}`;
      panel.append(all);
    }

    submenu.querySelectorAll('a').forEach((source) => {
      const link = document.createElement('a');
      link.className = 'district-mobile-nav__sublink';
      link.href = source.href;
      link.textContent = source.textContent.trim();
      panel.append(link);
    });

    details.append(panel);
    return details;
  }

  const sourceAnchor = directAnchor(item) || item.querySelector('a');
  if (!sourceAnchor) return null;

  const link = document.createElement('a');
  link.className = 'district-mobile-nav__link';
  link.href = sourceAnchor.href;
  link.textContent = sourceAnchor.textContent.trim();
  return link;
}

function buildMobileGroup(section, toggles, label, sourceLabel) {
  const toggle = toggles.find((candidate) => norm(candidate.textContent) === norm(sourceLabel));
  if (!toggle) return null;

  const id = toggle.getAttribute('data-id');
  if (!id) return null;

  const tab = [...section.querySelectorAll('[data-id]')].find(
    (candidate) => candidate !== toggle && candidate.getAttribute('data-id') === id && hasClassPrefix(candidate, 'header-menu-mobile-tab-')
  );
  if (!tab) return null;

  const list = directChildByPrefix(tab, 'ul', 'header-menu-list-');
  if (!list) return null;

  const details = document.createElement('details');
  details.className = 'district-mobile-nav__group';

  const summary = document.createElement('summary');
  summary.className = 'district-mobile-nav__summary';
  summary.textContent = label;
  details.append(summary);

  const panel = document.createElement('div');
  panel.className = 'district-mobile-nav__panel';

  [...list.children].forEach((item) => {
    if (item.tagName !== 'LI') return;
    const built = buildNestedGroup(item);
    if (built) panel.append(built);
  });

  details.append(panel);
  return details;
}

function buildMobileNavigation(section) {
  if (section.querySelector('.district-mobile-nav')) return;

  const toggleWrap = [...section.querySelectorAll('div')].find((el) => hasClassPrefix(el, 'header-menu-mobile-toggles-'));
  const mobileTop = [...section.querySelectorAll('div')].find((el) => hasClassPrefix(el, 'header-menu-mobile-top-'));
  if (!toggleWrap || !mobileTop) return;

  const toggles = [...toggleWrap.querySelectorAll('[data-id]')];
  const nav = document.createElement('nav');
  nav.className = 'district-mobile-nav';
  nav.setAttribute('aria-label', 'Navegación principal');

  const direct = (label, href, featured = false) => {
    const link = document.createElement('a');
    link.className = `district-mobile-nav__item${featured ? ' district-mobile-nav__item--featured' : ''}`;
    link.href = href;
    link.textContent = label;
    return link;
  };

  nav.append(direct('Harry Potter', '/collections/harry-potter', true));

  const universes = buildMobileGroup(section, toggles, 'Universos', 'Series & Películas');
  if (universes) nav.append(universes);

  const categories = buildMobileGroup(section, toggles, 'Categorías', 'Categorías');
  if (categories) nav.append(categories);

  nav.append(direct('Novedades', '/collections/novedades'));
  nav.append(direct('Más vendidos', '/collections/all?sort_by=best-selling'));

  const heading = [...section.querySelectorAll('*')].find((el) => hasClassPrefix(el, 'header-menu-mobile-heading-'));
  if (heading) heading.textContent = 'EXPLORA';

  mobileTop.insertAdjacentElement('afterend', nav);
}

function buildDesktopNavigation(section) {
  const lists = [...section.querySelectorAll('ul')].filter(
    (list) => hasClassPrefix(list, 'header-menu-list-') && !list.closest('[class*="header-menu-mobile-"]')
  );

  const list = lists.find((candidate) => {
    const text = norm(candidate.textContent);
    return text.includes('series & películas') && text.includes('categorías');
  });
  if (!list || list.classList.contains('district-desktop-nav')) return;

  const items = [...list.children].filter((child) => child.tagName === 'LI');
  const findItem = (label) => items.find((item) => norm(item.textContent).startsWith(norm(label)));

  const universesItem = findItem('Series & Películas');
  const categoriesItem = findItem('Categorías');
  const newsItem = findItem('Novedades');
  const aboutItem = findItem('¿Quiénes somos?');
  if (!universesItem || !categoriesItem || !newsItem || !aboutItem) return;

  const universeLabel = [...universesItem.children].find((child) => hasClassPrefix(child, 'header-menu-link-'));
  if (universeLabel) universeLabel.textContent = 'Universos';

  const makeDirect = (label, href) => {
    const item = aboutItem.cloneNode(true);
    const anchor = directAnchor(item) || item.querySelector('a');
    if (!anchor) return null;
    anchor.href = href;
    anchor.textContent = label;
    return item;
  };

  const hp = makeDirect('Harry Potter', '/collections/harry-potter');
  const news = makeDirect('Novedades', '/collections/novedades');
  const best = makeDirect('Más vendidos', '/collections/all?sort_by=best-selling');

  if (hp) list.insertBefore(hp, universesItem);
  if (news) newsItem.replaceWith(news);
  if (best) list.append(best);
  aboutItem.remove();

  list.classList.add('district-desktop-nav');
}

function initDistrictNavigation() {
  const toggleWrap = [...document.querySelectorAll('#header-group div')].find((el) =>
    hasClassPrefix(el, 'header-menu-mobile-toggles-')
  );
  const section = toggleWrap?.closest('.shopify-section');
  if (!section) return;

  buildMobileNavigation(section);
  buildDesktopNavigation(section);
  section.classList.add('district-nav-v2-ready');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDistrictNavigation, { once: true });
} else {
  initDistrictNavigation();
}

document.addEventListener('shopify:section:load', initDistrictNavigation);
